import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "how-it-works-page" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  class: "examples-section",
  "aria-label": "Usage examples"
}
const _hoisted_4 = { class: "slack-examples" }
const _hoisted_5 = { class: "message-row" }
const _hoisted_6 = { class: "slack-message" }
const _hoisted_7 = { class: "message-content" }
const _hoisted_8 = { class: "message-text" }
const _hoisted_9 = { class: "message-explanation" }
const _hoisted_10 = { class: "emoji-dropdown" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GettingStarted = _resolveComponent("GettingStarted")!
  const _component_ConditionalLayout = _resolveComponent("ConditionalLayout")!

  return (_openBlock(), _createBlock(_component_ConditionalLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "hero-section" }, [
            _createElementVNode("h1", null, "How it Works")
          ], -1)),
          _createElementVNode("section", _hoisted_3, [
            _cache[21] || (_cache[21] = _createElementVNode("h2", null, "See Prec8 in Action", -1)),
            _cache[22] || (_cache[22] = _createElementVNode("p", { class: "section-subtitle" }, "Here's how team recognition looks in your Slack workspace", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("article", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "message-header" }, [
                      _createElementVNode("span", { class: "username" }, "John Smith")
                    ], -1)),
                    _createElementVNode("div", _hoisted_8, [
                      _cache[12] || (_cache[12] = _createTextVNode(" Great work on the new feature release! ", -1)),
                      _cache[13] || (_cache[13] = _createElementVNode("span", { class: "mention" }, "@ari", -1)),
                      _createTextVNode(" your attention to detail really made this launch successful. " + _toDisplayString(_ctx.getCurrentEmoji()), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "explanation-title" }, "Custom Emoji Recognition", -1)),
                  _cache[16] || (_cache[16] = _createElementVNode("div", { class: "explanation-text" }, "Every team has their own vibe! Pick the emoji that feels right for your crew's way of saying \"you rock!\"", -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["emoji-option", { selected: _ctx.selectedEmojiIndex === 0 }]),
                      role: "button",
                      tabindex: "0",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedEmojiIndex = 0)),
                      onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.selectedEmojiIndex = 0), ["enter"]))
                    }, "🙏", 34),
                    _createElementVNode("div", {
                      class: _normalizeClass(["emoji-option", { selected: _ctx.selectedEmojiIndex === 1 }]),
                      role: "button",
                      tabindex: "0",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedEmojiIndex = 1)),
                      onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.selectedEmojiIndex = 1), ["enter"]))
                    }, "👏", 34),
                    _createElementVNode("div", {
                      class: _normalizeClass(["emoji-option", { selected: _ctx.selectedEmojiIndex === 2 }]),
                      role: "button",
                      tabindex: "0",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedEmojiIndex = 2)),
                      onKeydown: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.selectedEmojiIndex = 2), ["enter"]))
                    }, "🍩", 34),
                    _createElementVNode("div", {
                      class: _normalizeClass(["emoji-option", { selected: _ctx.selectedEmojiIndex === 3 }]),
                      role: "button",
                      tabindex: "0",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedEmojiIndex = 3)),
                      onKeydown: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.selectedEmojiIndex = 3), ["enter"]))
                    }, "💪", 34),
                    _createElementVNode("div", {
                      class: _normalizeClass(["emoji-option", { selected: _ctx.selectedEmojiIndex === 4 }]),
                      role: "button",
                      tabindex: "0",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectedEmojiIndex = 4)),
                      onKeydown: _cache[9] || (_cache[9] = _withKeys(($event: any) => (_ctx.selectedEmojiIndex = 4), ["enter"]))
                    }, "⭐", 34),
                    _createElementVNode("div", {
                      class: _normalizeClass(["emoji-option", { selected: _ctx.selectedEmojiIndex === 5 }]),
                      role: "button",
                      tabindex: "0",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectedEmojiIndex = 5)),
                      onKeydown: _cache[11] || (_cache[11] = _withKeys(($event: any) => (_ctx.selectedEmojiIndex = 5), ["enter"]))
                    }, "🏆", 34)
                  ]),
                  _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                  _cache[18] || (_cache[18] = _createElementVNode("div", { class: "explanation-text" }, [
                    _createTextVNode("In this example, "),
                    _createElementVNode("span", { class: "mention" }, "@ari"),
                    _createTextVNode(" gets 1 "),
                    _createElementVNode("span", { class: "appreciation-token-text" }, "appreciation token")
                  ], -1))
                ])
              ]),
              _cache[19] || (_cache[19] = _createElementVNode("article", { class: "message-row" }, [
                _createElementVNode("div", { class: "slack-message" }, [
                  _createElementVNode("div", { class: "message-content" }, [
                    _createElementVNode("div", { class: "message-header" }, [
                      _createElementVNode("span", { class: "username" }, "Mike Brown")
                    ]),
                    _createElementVNode("div", { class: "message-text" }, [
                      _createTextVNode(" 🙏 🙏 🙏 Just wanted to recognize "),
                      _createElementVNode("span", { class: "mention" }, "@sarah"),
                      _createTextVNode(" for her amazing presentation skills in the client meeting today. ")
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "message-explanation" }, [
                  _createElementVNode("div", { class: "explanation-title" }, "Super Boost Recognition"),
                  _createElementVNode("div", { class: "explanation-text" }, [
                    _createTextVNode("Each emoji corresponds to one "),
                    _createElementVNode("span", { class: "appreciation-token-text" }, "appreciation token"),
                    _createTextVNode(", in this instance "),
                    _createElementVNode("span", { class: "mention" }, "@sarah"),
                    _createTextVNode(" gets 3. Stack 'em up for extra impact! ")
                  ])
                ])
              ], -1)),
              _cache[20] || (_cache[20] = _createElementVNode("article", { class: "message-row" }, [
                _createElementVNode("div", { class: "slack-message" }, [
                  _createElementVNode("div", { class: "message-content" }, [
                    _createElementVNode("div", { class: "message-header" }, [
                      _createElementVNode("span", { class: "username" }, "Alice Johnson")
                    ]),
                    _createElementVNode("div", { class: "message-text" }, [
                      _createTextVNode(" Thanks 🙏 "),
                      _createElementVNode("span", { class: "mention" }, "@steve"),
                      _createTextVNode(" and "),
                      _createElementVNode("span", { class: "mention" }, "@alex"),
                      _createTextVNode(" for the help with debugging yesterday! Couldn't have solved it without you. ")
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "message-explanation" }, [
                  _createElementVNode("div", { class: "explanation-title" }, "Team Recognition"),
                  _createElementVNode("div", { class: "explanation-text" }, [
                    _createTextVNode("Spread the love! Tag multiple people and they all get points. "),
                    _createElementVNode("span", { class: "mention" }, "@steve"),
                    _createTextVNode(" and "),
                    _createElementVNode("span", { class: "mention" }, "@alex"),
                    _createTextVNode(" both score appreciation tokens! 🎯")
                  ])
                ])
              ], -1))
            ])
          ]),
          _cache[24] || (_cache[24] = _createElementVNode("section", {
            class: "features-deep-dive",
            "aria-label": "Detailed features"
          }, [
            _createElementVNode("h2", null, "Key Features That Make Recognition Easy"),
            _createElementVNode("div", { class: "feature-details" }, [
              _createElementVNode("div", { class: "feature-detail" }, [
                _createElementVNode("h3", null, "🎯 Daily Point System"),
                _createElementVNode("p", null, "Every team member gets 10 points to give each day, ensuring recognition happens regularly and fairly. Points reset at midnight in your workspace's timezone.")
              ]),
              _createElementVNode("div", { class: "feature-detail" }, [
                _createElementVNode("h3", null, "📊 Real-Time Analytics"),
                _createElementVNode("p", null, "Track recognition patterns, see who's giving and receiving the most appreciation, and understand your team's culture through data.")
              ]),
              _createElementVNode("div", { class: "feature-detail" }, [
                _createElementVNode("h3", null, "🏆 Leaderboards & Rewards"),
                _createElementVNode("p", null, "Friendly competition motivates teams. Use points to redeem rewards and celebrate achievements together.")
              ]),
              _createElementVNode("div", { class: "feature-detail" }, [
                _createElementVNode("h3", null, "🔒 Privacy & Security"),
                _createElementVNode("p", null, "All recognition data stays within your workspace. Enterprise-grade security ensures your team's information is protected.")
              ])
            ])
          ], -1)),
          (!_ctx.isAuthenticated)
            ? (_openBlock(), _createBlock(_component_GettingStarted, { key: 0 }))
            : _createCommentVNode("", true),
          _cache[25] || (_cache[25] = _createElementVNode("section", {
            class: "faq-section",
            "aria-label": "Frequently asked questions"
          }, [
            _createElementVNode("h2", null, "Frequently Asked Questions"),
            _createElementVNode("div", { class: "faq-list" }, [
              _createElementVNode("details", { class: "faq-item" }, [
                _createElementVNode("summary", null, "How many points can I give each day?"),
                _createElementVNode("p", null, "Each team member gets 10 points to give daily. These reset at midnight in your workspace's timezone, encouraging regular recognition.")
              ]),
              _createElementVNode("details", { class: "faq-item" }, [
                _createElementVNode("summary", null, "Can I give points to multiple people at once?"),
                _createElementVNode("p", null, "Yes! Tag multiple people in your message and they'll all receive points. Each emoji equals one point per person.")
              ]),
              _createElementVNode("details", { class: "faq-item" }, [
                _createElementVNode("summary", null, "What happens to the points I receive?"),
                _createElementVNode("p", null, "Points you receive become redeemable tokens that you can use for rewards, or they can be tracked as part of your recognition history.")
              ])
            ])
          ], -1))
        ])
      ])
    ]),
    _: 1
  }))
}